import React from 'react';
import { WixComponentTypes } from '@wix/shoutout-email-model-v3';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
const HOPP_LINK_STYLE = {
  color: '#000000',
  fontWeight: 'bold',
  textDecoration: 'underline'
};

/**
 * When using in another package, first "loadStrings" from wix-emails-senders/src/i18n.ts
 * needs to be loaded in a corresponding package's i18n.ts file and/or essentials provider
 */
export const useWixFooterContent = () => {
  const {
    t
  } = useTranslation();
  const content = {
    dontReply: t('wix.footer.content.dont.reply'),
    helpCenter: t('wix.footer.content.help.center'),
    helpCenterUrl: t('wix.footer.content.help.center.url'),
    privacyPolicy: t('wix.footer.content.privacy.policy'),
    privacyPolicyUrl: t('wix.footer.content.privacy.policy.url'),
    termsOfUse: t('wix.footer.content.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.terms.of.use.url'),
    companyAddressLine: t('wix.footer.content.company.address')
  };
  const paymentsContent = {
    ...content,
    termsOfUse: t('wix.footer.content.payments.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.payments.terms.of.use.url')
  };
  const paymentsBrazilContent = {
    ...paymentsContent,
    paymentsBrazilCompliance: t('wix.footer.content.payments.brazil.compliance'),
    paymentsBrazilNeedHelp: t('wix.footer.content.payments.brazil.need.help'),
    paymentsBrazilAddressLine1: t('wix.footer.content.payments.brazil.address.line.1'),
    paymentsBrazilAddressLine2: t('wix.footer.content.payments.brazil.address.line.2'),
    paymentsBrazilAddressLine3: t('wix.footer.content.payments.brazil.address.line.3'),
    paymentsBrazilCompanyLine: t('wix.footer.content.payments.brazil.company.line'),
    paymentsBrazilTermsNotice: t('wix.footer.content.payments.brazil.terms.notice'),
    paymentsBrazilTermsOfServiceUrl: t('wix.footer.content.payments.brazil.terms.of.service.url'),
    paymentsBrazilUnsupportedBusinessModelsUrl: t('wix.footer.content.payments.brazil.unsupported.business.models.url'),
    paymentsBrazilVerificationRequirementsUrl: t('wix.footer.content.payments.brazil.verification.requirements.url'),
    paymentsBrazilContactCustomerCareUrl: t('wix.footer.content.payments.brazil.contact.customer.care.url')
  };
  const riseContent = {
    ...content,
    helpCenterUrl: t('wix.footer.content.rise.help.center.url'),
    privacyPolicyUrl: t('wix.footer.content.rise.privacy.policy.url'),
    termsOfUse: t('wix.footer.content.rise.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.rise.terms.of.use.url'),
    companyAddressLine: t('wix.footer.content.rise.company.address')
  };
  const hoppContent = {
    ...content,
    helpCenterUrl: t('wix.footer.content.hopp.help.center.url'),
    needHelp: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "wix.footer.content.hopp.need.help",
      components: [/*#__PURE__*/React.createElement("a", {
        href: t('wix.footer.content.hopp.help.center.url'),
        style: HOPP_LINK_STYLE
      }), /*#__PURE__*/React.createElement("a", {
        href: t('wix.footer.content.hopp.contact.us.url'),
        style: HOPP_LINK_STYLE
      })]
    })
  };
  const footerMap = {
    [WixComponentTypes.classic]: content,
    [WixComponentTypes.studio]: content,
    [WixComponentTypes.payments]: paymentsContent,
    [WixComponentTypes.paymentsBrazil]: paymentsBrazilContent,
    [WixComponentTypes.rise]: riseContent,
    [WixComponentTypes.hopp]: hoppContent
  };
  const getWixFooterContent = wixFooterType => footerMap[wixFooterType] ?? content;
  return {
    getWixFooterContent
  };
};
//# sourceMappingURL=useWixFooterContent.js.map